// `getSentryInstance` / `setSentryInstance` should only be used to configure
// the Sentry instance singleton. Which should only be needed for internal use
// inside of the Sentry integration domain. It is *not* recommended for use in
// other domains. See more about the idiosyncratic Sentry configuration here:
// ../README.md#idiosyncratic-sentry-configuration
let _SentryInstance = {
  captureException: (error) => {
    // Allows developers to silence extra noise on their local dev test runner executions using:
    //   - `export NEXT_PUBLIC_SILENCE_SENTRY=1`
    if (process?.env?.NEXT_PUBLIC_SILENCE_SENTRY) return;
    console.error(
      "Sentry has not been initialized, the following error will *not* be logged to Sentry",
    );
    console.error(error);
  },
  captureMessage: () => {
    // Stub method to mimic the Sentry interface.
  },
};
export const getSentryInstance = () => {
  return _SentryInstance;
};
export const setSentryInstance = (SentryInstance) => {
  _SentryInstance = SentryInstance;
};
